// extracted by mini-css-extract-plugin
module.exports = {"chatbox":"Chat_chatbox__14HzS","answerSelected":"Chat_answerSelected__1PG9L"};